import { CheckCircle, Activity, AlertCircle } from "lucide-react";

interface StatusIconProps {
	status: string;
}

export function StatusIcon({ status }: StatusIconProps) {
	switch (status) {
		case "completed":
			return <CheckCircle className="h-3 w-3" />;
		case "in_progress":
			return <Activity className="h-3 w-3" />;
		default:
			return <AlertCircle className="h-3 w-3" />;
	}
}
